export default __webpack_public_path__ + "static/media/JPG輪播2-8.1df849ad.jpg";